<template>
  <div v-if="confirmDialogState.visible" class="modal-overlay" @click.self="settleConfirmDialog(false)">
    <div class="confirm-modal" role="dialog" aria-modal="true" aria-labelledby="global-confirm-title">
      <h4 id="global-confirm-title" class="confirm-title">{{ confirmDialogState.title }}</h4>
      <p class="confirm-message">{{ confirmDialogState.message }}</p>
      <div class="modal-actions">
        <button type="button" class="btn-cancel" @click="settleConfirmDialog(false)">
          {{ confirmDialogState.cancelText }}
        </button>
        <button type="button" class="btn-confirm" @click="settleConfirmDialog(true)">
          {{ confirmDialogState.confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { confirmDialogState, settleConfirmDialog } from '../utils/confirmDialogState'
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm-modal {
  background: #1a2535;
  border: 1px solid #3a5070;
  border-radius: 10px;
  padding: 20px;
  min-width: 320px;
  max-width: 440px;
}

.confirm-title {
  margin: 0 0 10px;
  color: #e0f0ff;
  font-size: 14px;
  font-weight: 600;
}

.confirm-message {
  margin: 0 0 18px;
  color: #a0b0c4;
  font-size: 13px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
}

.modal-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}

.btn-cancel,
.btn-confirm {
  padding: 6px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  border: 1px solid;
  transition: background 0.14s ease;
}

.btn-cancel {
  background: #243040;
  border-color: #3a4a60;
  color: #aac;
}

.btn-cancel:hover {
  background: #2e3c50;
}

.btn-confirm {
  background: #2d6bd8;
  border-color: #2d6bd8;
  color: #fff;
}

.btn-confirm:hover {
  background: #3a7ce8;
}
</style>
